// extracted by mini-css-extract-plugin
module.exports = {"rating":"fm","numberOfStars":"gm"};